import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { OktaAuth, OktaAuthOptions, toRelativeUrl } from '@okta/okta-auth-js';
import { Security, SecureRoute, LoginCallback } from '@okta/okta-react';
import { environment } from './environments/environment';
import { useHistory } from 'react-router-dom';
import Home from './pages/Home/Home';
import React from 'react';
import Login from './pages/Login/Login';
import OktaError from './pages/OktaError/OktaError';

const config: OktaAuthOptions = {
    clientId: environment.oktaConfig.clientId,
    issuer: environment.oktaConfig.issuer,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'address', 'email'],
    pkce: true,

    // @ts-expect-error disableHttpsCheck is missing from OktaAuthOptions
    disableHttpsCheck: environment.oktaConfig.disableHTTPsCheck
};

const oktaAuth = new OktaAuth(config);

const App = () => {
    const history = useHistory();
    const restoreOriginalUri = async (_oktaAuth: unknown, originalUri: string) => {
        history.replace(toRelativeUrl(originalUri, window.location.origin));
    };
    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <Switch>
                <Route path="/login/callback" render={(props) => <LoginCallback {...props} errorComponent={OktaError} />} />
                {/* <Route path="/login/callback" component={LoginCallback} /> */}
                <SecureRoute path="/login" exact component={Login} />
                <Route path="/" component={Home} />
            </Switch>
        </Security>
    );

};

const Router = () => {
    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
};

export default Router;

